import { ChatTitleUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/assistant/v1/events_pb';
import { Col, FieldDisplay, IDField } from '@rematter/ui-web';

import { useTranslations } from '../../../i18n/useTranslations';

type ChatTitleUpdatedDetailProps = {
  event: ChatTitleUpdatedEvent;
};

//
// ⚛️ ⚛️ ⚛️ CHAT TITLE UPDATED DETAIL ⚛️ ⚛️ ⚛️
//
export const ChatTitleUpdatedDetail = ({
  event,
}: ChatTitleUpdatedDetailProps) => {
  const t = useTranslations();

  return (
    <Col className="@ChatTitleUpdatedDetail" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          {t.logs.titleUpdate}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label={t.logs.fields.chatId} value={event.chatId?.value} />
          <FieldDisplay label={t.logs.fields.newTitle} value={event.title} />
        </div>
      </Col>
    </Col>
  );
};
